<div class="content content-fixed">
  <div class="container">
    <section fxLayout="column wrap" fxLayoutGap="60px" fxLayoutAlign="center center">
      <div fxFlex>
        404
      </div>
      <div fxFlex>
        Page not found
      </div>
      <div fxFlex>
        Maybe the page you are looking for has been removed, or you typed in the wrong URL
      </div>
      <div fxFlex>
        <a routerLink="/home">{{'GO TO HOMEPAGE' | translate}}</a>
      </div>
    </section>
 </div>
</div>

